import React from 'react';
import { Card, Row, Col, Typography } from 'antd';
import { TeamOutlined, GlobalOutlined } from '@ant-design/icons';
import ChartContainer from '../../components/shared/ChartContainer';
import { mockClientAnalyticsData } from '../data/mockData';

const { Title, Text } = Typography;

const DemographicsChart: React.FC = () => {
  const { demographics } = mockClientAnalyticsData;

  // Age distribution chart
  const ageChartData = {
    labels: demographics.ageDistribution.map(item => item.range),
    datasets: [
      {
        label: 'Client Count',
        data: demographics.ageDistribution.map(item => item.count),
        backgroundColor: [
          '#1890ff',
          '#52c41a',
          '#faad14',
          '#f5222d',
          '#722ed1',
        ],
      },
    ],
  };

  // Gender distribution chart
  const genderChartData = {
    labels: demographics.genderDistribution.map(item => item.gender),
    datasets: [
      {
        label: 'Client Count',
        data: demographics.genderDistribution.map(item => item.count),
        backgroundColor: ['#722ed1', '#1890ff', '#52c41a'],
      },
    ],
  };

  // Tier distribution chart
  const tierChartData = {
    labels: demographics.tierDistribution.map(item => item.tier),
    datasets: [
      {
        label: 'Client Count',
        data: demographics.tierDistribution.map(item => item.count),
        backgroundColor: ['#faad14', '#52c41a', '#1890ff'],
      },
      {
        label: 'Revenue ($)',
        data: demographics.tierDistribution.map(item => item.revenue),
        backgroundColor: ['#ff7875', '#73d13d', '#40a9ff'],
        yAxisID: 'y1',
      },
    ],
  };

  // Location distribution chart
  const locationChartData = {
    labels: demographics.locationDistribution.map(item => item.location),
    datasets: [
      {
        label: 'Client Count',
        data: demographics.locationDistribution.map(item => item.count),
        backgroundColor: ['#1890ff', '#52c41a', '#faad14', '#f5222d'],
      },
    ],
  };

  return (
    <div>
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col span={12}>
          <ChartContainer
            title="Age Distribution"
            type="pie"
            data={ageChartData}
            height={300}
          />
        </Col>
        <Col span={12}>
          <ChartContainer
            title="Gender Distribution"
            type="pie"
            data={genderChartData}
            height={300}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={12}>
          <ChartContainer
            title={
              <span>
                <TeamOutlined /> Client Tier Distribution
              </span>
            }
            type="bar"
            data={tierChartData}
            height={300}
          />
        </Col>
        <Col span={12}>
          <ChartContainer
            title={
              <span>
                <GlobalOutlined /> Geographic Distribution
              </span>
            }
            type="bar"
            data={locationChartData}
            height={300}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col span={24}>
          <Card title="Demographics Summary">
            <Row gutter={[16, 16]}>
              <Col span={6}>
                <div style={{ textAlign: 'center' }}>
                  <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                    {demographics.ageDistribution.find(item => item.range === '26-35')?.percentage.toFixed(1)}%
                  </Title>
                  <Text type="secondary">Primary Age Group (26-35)</Text>
                </div>
              </Col>
              <Col span={6}>
                <div style={{ textAlign: 'center' }}>
                  <Title level={3} style={{ margin: 0, color: '#722ed1' }}>
                    {demographics.genderDistribution.find(item => item.gender === 'Female')?.percentage.toFixed(1)}%
                  </Title>
                  <Text type="secondary">Female Clients</Text>
                </div>
              </Col>
              <Col span={6}>
                <div style={{ textAlign: 'center' }}>
                  <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                    {demographics.tierDistribution.find(item => item.tier === 'Standard')?.percentage.toFixed(1)}%
                  </Title>
                  <Text type="secondary">Standard Tier</Text>
                </div>
              </Col>
              <Col span={6}>
                <div style={{ textAlign: 'center' }}>
                  <Title level={3} style={{ margin: 0, color: '#faad14' }}>
                    {demographics.locationDistribution.find(item => item.location === 'North America')?.percentage.toFixed(1)}%
                  </Title>
                  <Text type="secondary">North America</Text>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DemographicsChart; 